import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ApiSearchUtilService } from "../api-search-util/api-search-util.service";

@Injectable({
  providedIn: "root",
})
export class UrlUtilService {
  private actionDetail$ = new Subject<any>();
  constructor(
    private apiSearchUtil: ApiSearchUtilService
  ) { }

  convertObjectToSearchParam(obj: object): string {
    const params = new URLSearchParams();
    // tslint:disable-next-line: forin
    for (const key in obj) {
      params.set(key, obj[key] ?? "");
    }
    return params.toString();
  }

  get details() {
    return this.actionDetail$.asObservable();
  }

  setActionObjectDetail(detail) {
    if (!detail) {
      return;
    }

    this.actionDetail$.next(detail);
  }

  getDefaultHeaders() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    });

    return headers;
  }

  getBodyWithCustomerIds(body: any) {
    body.customerId = this.apiSearchUtil.getConcatenatedCustomerIdsFromSession();
    return body;
  }

  getBodyWithCustomerRefs(body: any) {
    body.customerId = this.apiSearchUtil.getConcatenatedCustomerRefsFromSession();
    return body;
  }
  
}
